import { render, staticRenderFns } from "./SlideViewer.vue?vue&type=template&id=23471d52&scoped=true"
import script from "./SlideViewer.vue?vue&type=script&lang=js"
export * from "./SlideViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23471d52",
  null
  
)

export default component.exports